import React from "react";
import "./IndexPage.scss"
import {ArticleType} from "../../api/model/Article";
import ArticleCard from "../../components/ArticleCard/ArticleCard";
import {RouteComponentProps} from 'react-router-dom'

export default function IndexPage(props: IProp) {

    function onNavigateToDetail(id: number) {
        props.history.push({
            pathname: '/article/detail/' + String(id),
        })
    }

    function onNavigateToList(type: ArticleType) {
        props.history.push({
            pathname: '/article/' + type,
        })
    }

    return (
        <div className="IndexPage">
            <ArticleCard type="研究院介绍" onNavigateToDetail={onNavigateToDetail} onNavigateToList={() => {
                onNavigateToList("研究院介绍")
            }}/>
            <br/>
            <ArticleCard type="课程体系" onNavigateToDetail={onNavigateToDetail} onNavigateToList={() => {
                onNavigateToList("课程体系")
            }}/>
            <br/>
            <ArticleCard type="研究报告" onNavigateToDetail={onNavigateToDetail} onNavigateToList={() => {
                onNavigateToList("研究报告")
            }}/>
        </div>
    )
}

interface IProp extends RouteComponentProps {
}
